/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".policy-selector[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{border-top-width:1px}.selected-policy[_ngcontent-%COMP%]{position:absolute;top:20px;right:20px}.active_policy[_ngcontent-%COMP%]{background-color:#007ac9}.type2[_ngcontent-%COMP%]{margin:0 34px}\n/*# sourceMappingURL=mobile-selector.component.css.map*/"];
export { styles as styles };
